<template>
  <nav class="breadcrumb" :aria-label="$t('breadcrumbs')">
    <ul>
      <li v-for="(item, index) in items" :key="index">
        <router-link :to="item.to" class="breadcrumb-link">
          <b-icon v-if="item.icon" :icon="item.icon" class="icon" />
          <template v-if="item.subLabels">
            {{ item.label }}
            <span v-for="(subLabel, index) of item.subLabels" :key="index">
              <span> &nbsp; / </span>{{ subLabel }}
            </span>
          </template>
          <template v-else>
            {{ item.label }}
          </template>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.breadcrumb {
  margin-left: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Media query for screens less than 1200px wide */
@media (max-width: 1600px) {
  .breadcrumb {
    max-width: 500px; /* Set maximum width to 300px */
  }
}

@media (max-width: 1300px) {
  .breadcrumb {
    max-width: 300px; /* Set maximum width to 300px */
  }
}
@media (max-width: 1100px) {
  .breadcrumb {
    max-width: 200px; /* Set maximum width to 300px */
  }
}

.icon {
  font-size: 20px;
  color: gray;
  margin-top: 0.2rem;
}

.breadcrumb ul {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  white-space: nowrap;
}

.breadcrumb li:not(:last-child) {
  margin-right: 0.5rem;
}

.breadcrumb li:last-child {
  font-weight: bold;
}

.breadcrumb li + li::before {
  color: #b5b5b5;
  content: '\003e';
}

.breadcrumb-link {
  font-size: 18px;
  text-decoration: none;
  color: #333;
}

.breadcrumb-link:hover {
  text-decoration: underline !important;
}
</style>
